/**
 * @date: 12/11/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */
import React from "react";
import KeyValuePair from "../utils/components/KeyValuePair";
import {getDateFromString} from "../utils/cert-helper";
import {Alert} from '@mui/material'

export default function UserProfileWidget(props){

    const user = props.user;

    if (!user){
        return <Alert color='warning'>No user is found</Alert>;
    }
    return (
        <div>
            <h3>{user.familyName}, {user.givenName}</h3>
            <KeyValuePair name="Role" value={user.userType} />
            <KeyValuePair name="Email" value={user.email} />
            {user.phone &&  <KeyValuePair name="Phone" value={user.phone} /> }
            <KeyValuePair name="Status" value={user.status} />
            {user.lastLoginTs &&
                <KeyValuePair name="Last Login" value={getDateFromString(user.lastLoginTs).toISOString()}/>
            }
        </div>
    )
}
